import { render, staticRenderFns } from "./DeleteZone.vue?vue&type=template&id=6438120e&"
import script from "./DeleteZone.vue?vue&type=script&lang=js&"
export * from "./DeleteZone.vue?vue&type=script&lang=js&"
import style0 from "./DeleteZone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports